export default "__VITE_ASSET__k77aEMju__"